import Select from 'app/frontend/base/components/Select'
import CharacterClassIcon from 'app/frontend/base/components/CharacterClassIcon'
import { useClaimExistingManualCharacter } from 'app/frontend/base/config/mutations'
import { classColours } from 'app/frontend/types/custom/CharacterClass'
import { cn } from '@/lib/utils'

type Props = {
  characters: wowaudit.CharacterReference[]
  inModal?: boolean
  onClaimed?: () => void
  className?: string
}

const ClaimExistingCharacterButton = ({
  characters,
  inModal,
  onClaimed,
  className,
}: Props) => {
  const { mutate, isPending } = useClaimExistingManualCharacter()

  if (characters.length === 0) return null

  return (
    <Select
      options={characters.map((character) => ({
        value: character.id.toString(),
        sortLabel: character.name,
        label: (
          <span
            className={cn(
              'flex items-center gap-2',
              classColours[character.characterClass].text,
            )}
          >
            <CharacterClassIcon
              size='small'
              characterClass={character.characterClass}
            />
            {character.name}
          </span>
        ),
      }))}
      setValue={(value) => {
        const character = characters.find((c) => c.id.toString() === value)
        if (character) mutate(character, { onSuccess: onClaimed })
      }}
      placeholder={<span className='text-foreground'>Claim existing</span>}
      disabled={isPending}
      optionWidth='fit'
      className={cn('w-auto h-9', className)}
      isSearchable
      hideIcon
      inModal={inModal}
    />
  )
}

export default ClaimExistingCharacterButton
